import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/atlassian': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M152.2 236.4C144.5 228.2 132.5 228.7 127.4 239.2L1.6 490.2C-3.4 500.2 4 511.9 15 511.9H190C195.8 512 201 508.7 203.4 503.5 241.3 425.7 218.5 307.2 152.2 236.4zM244.4 8.1C122.1 201.5 235.9 356.7 309.4 503.6 311.9 508.7 317.1 512 322.8 512H497C508.2 512 515.4 500.2 510.4 490.3 510.4 490.3 275.9 19.7 270 8 264.7-2.6 251.2-2.8 244.4 8.1z'
      }
    ]
  }
})
